import { EditableInput as e } from "../../design/forms/editable/index.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
// src/components/data-table/EditableCell.tsx
var r = t.memo(({ value: r, row: i, columnId: a, rowIndex: o, isEditing: s, onStartEdit: c, onSave: l, onCancel: u, renderEditCell: d }) => {
	let [f, p] = t.useState(r);
	t.useEffect(() => {
		p(r);
	}, [r]);
	let m = t.useCallback(() => {
		f === r ? u() : l(f);
	}, [
		f,
		r,
		l,
		u
	]), h = t.useCallback((e) => {
		p(e);
	}, []), g = t.useCallback((e) => {
		let t = e.value;
		t === r ? u() : l(t);
	}, [
		r,
		l,
		u
	]);
	return s ? d ? /* @__PURE__ */ n("div", {
		className: "w-full",
		children: d({
			value: f,
			onChange: h,
			onSave: m,
			onCancel: u,
			row: i,
			columnId: a,
			rowIndex: o
		})
	}) : /* @__PURE__ */ n("div", {
		className: "w-full -mx-2 -my-1",
		children: /* @__PURE__ */ n(e, {
			value: f || "",
			onValueCommit: g,
			onValueChange: (e) => p(e.value),
			activationMode: "dblclick",
			autoResize: !0,
			placeholder: "Empty",
			config: { size: "sm" },
			showControls: !0
		})
	}) : /* @__PURE__ */ n("div", {
		onClick: c,
		className: "cursor-pointer hover:bg-muted px-2 py-1 rounded transition-colors min-h-6",
		title: "Click to edit",
		children: r || /* @__PURE__ */ n("span", {
			className: "text-muted-foreground italic",
			children: "Empty"
		})
	});
}, (e, t) => e.value === t.value && e.isEditing === t.isEditing && e.rowIndex === t.rowIndex && e.columnId === t.columnId);
r.displayName = "EditableCell";
export { r as EditableCell };

//# sourceMappingURL=EditableCell.js.map